import TimeSheets from "../../components/TimeSheetsAdmin/index";

const TimeSheet = () => {
  return (
    <>
      <TimeSheets />
    </>
  );
};

export default TimeSheet;
